import { Directive, ElementRef, AfterViewInit, inject } from "@angular/core";
import { trapFocus } from "../../../app/app.utils";

@Directive({
  selector: "[avTrapFocus]",
  standalone: false,
})
export class TrapFocusDirective implements AfterViewInit {
  private el = inject(ElementRef);


  ngAfterViewInit() {
    trapFocus(this.el.nativeElement);
  }
}
